<template>
  <div>
    <div class="col-12">
      <div class="row mt-3">
        <div class="col-6">
          <h2 class="">لیست اشتراک ها</h2>
        </div>

        <div class="col-6">
          <div class="text-left">
            <router-link :to="{ name: 'CreatSubscription' }">
              <b-button pill variant="purple" class="ml-1 "
              >ساخت اشتراک
              </b-button
              >
            </router-link>
          </div>
        </div>

      </div>
    </div>
    <table class="table my-3 table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
      <thead>
      <tr>
        <th>شناسه</th>
        <th>نام</th>
        <th>نوع اشتراک</th>
        <th>ویرایش / حذف</th>

      </tr>
      </thead>

      <tr v-for="item in subscriptions">
        <th>{{ item.id }}</th>
        <th>{{ item.name }}</th>
        <th>{{ item.value_type }}</th>
        <th>
          <router-link target="_blank" class="p"
                       :to="{ name: 'UpdateSubscription', params: { id: item.id } }">
            <b-icon icon="pencil" class="mr-3"></b-icon>
          </router-link>
          <b-icon @click="deleteSubscription(item)" icon="trash" class="mr-4 cursor-pointer text-danger"></b-icon>
        </th>

      </tr>
    </table>

    <div class="row justify-content-center pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>

  </div>
</template>


<script>

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import Pagination from "../Pagination.vue";

export default {
  name: "AllSubscription",
  components: {Pagination},
  data() {
    return {
      subscriptions: [],
      paginationMeta: {},
    }
  },
  methods: {
    async loadSubscription(page = 1) {
      let req = await this.$store.dispatch('Subscription/getSubscriptions', page)
      let data = req.data.data
      this.subscriptions = data.data
      this.paginationMeta = data.meta
    },
    async deleteSubscription(item) {

      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('Subscription/deleteSubscription', item).then(res => {
          this.loadSubscription()
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }

    },
    changePage(page) {
      this.loadSubscription(page)
    }
  },
  mounted() {
    this.loadSubscription()
  }


}

</script>

<style scoped>

</style>